import { httpClient } from 'Shared/network';
import { QUERY_KEY } from '@constants';
import type { GetBannersOkDto } from 'viewup-api';

export const getBanners = async (): Promise<GetBannersOkDto> => {
  const { data } = await httpClient.get<GetBannersOkDto>(QUERY_KEY.BANNERS);
  return data;
};
